export default __webpack_public_path__ + "static/media/Q0003.ba46f206.png";